import { useEffect, useState } from 'react';
import { CustomTagManager } from '../../utils/GTM';
import PageContainer from '../../components/PageContainer';
import FlipClock from '../../components/FlipClock';
import useQueryString from '../../hooks/useQueryString';
import Preview from '../../components/Preview';
import DownloadButtons from '../../components/DownloadButtons';
import Guide from '../../components/Guide';
import AppBanner from '../../components/AppBanner';
import AppPopup from '../../components/AppPopup';
import logo from './assets/logo.png';
import {
  defaultColor,
  DownloadPageWrap,
  LogoWrap,
} from './styles/default.style';

const DownloadPage = () => {
  const { sessionId, countryCode } = useQueryString();

  // UZ(우즈베키스탄), PH(필리핀)의 경우 앱 배너 및 팝업 표시하지 않음
  const hideAppBanner = countryCode === 'UZ' || countryCode === 'PH';

  const [showPopup, setShowPopup] = useState(false);
  const [isPopupShowed, setPopupShowed] = useState(false);

  useEffect(() => {
    CustomTagManager.QR_Download_Page_View();
  }, []);

  const handleOpenPopupWhenPopupNotShowed = () => {
    if (!hideAppBanner) {
      if (!isPopupShowed) {
        setShowPopup(true);
        setPopupShowed(true);
        CustomTagManager.QR_Download_Page_Popup_Ranking();
      }
    }
  };

  const buttonColor = {
    $backgroundColor: defaultColor.main,
    $textColor: defaultColor.secondary,
    $iconColor: defaultColor.secondary,
    $borderGradientTop: defaultColor.gradientTop,
    $borderGradientBottom: defaultColor.gradientBottom,
  };

  return (
    <PageContainer $backgroundColor={defaultColor.main}>
      <AppPopup isOpen={showPopup} onClose={() => setShowPopup(false)} />

      <DownloadPageWrap>
        {hideAppBanner ? (
          <LogoWrap>
            <img src={logo} alt="PHOTOGRAY" />
          </LogoWrap>
        ) : (
          <AppBanner $isFixedTop={false} />
        )}
        <FlipClock
          $clockColor={defaultColor.clock}
          $dotColor={defaultColor.clock}
        />
        <Preview sessionId={sessionId} videoWidth={320} />
        <DownloadButtons
          buttonColor={buttonColor}
          sessionId={sessionId}
          photoDownloadCallback={handleOpenPopupWhenPopupNotShowed}
        />
        <Guide style={{ paddingBottom: '48px' }} />
      </DownloadPageWrap>
    </PageContainer>
  );
};

export default DownloadPage;
